<template>
    <v-col cols="12" sm="6" md="6" lg="8" xl="8">
        <v-card>
            <v-toolbar flat dense color="grey lighten-4">
                <v-toolbar-title>
                    {{ widget.body.title }}
                </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-card-text>
                <v-container class="pa-0 pb-1">
                    <v-row>
                        <v-col
                            class="pa-0"
                            cols="12"
                            sm="12"
                            md="6"
                            lg="8"
                        >
                            <v-btn
                                text
                                icon
                                data-sentry-label="Poprzedni miesiąc"
                                color="blue-grey"
                                :disabled="disableBackward"
                                @click="previousMonth()"
                            >
                                <v-icon>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                            <span class="text-subtitle-2">
                                {{ currentMonth }} {{ currentYear }}
                            </span>
                            <v-btn
                                text
                                icon
                                data-sentry-label="Następny miesiąc"
                                color="blue-grey"
                                :disabled="disableForward"
                                @click="nextMonth()"
                            >
                                <v-icon>
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </v-col>

                        <v-col
                            class="pa-0 pb-1"
                            cols="12"
                            sm="12"
                            md="6"
                            lg="4"
                        >
                            <v-select
                                v-model="source"
                                :items="sources"
                                item-value="id"
                                item-text="name"
                                hide-details
                                return-object
                                no-data-text="Nie znaleziono prefiksu"
                                outlined
                                dense
                                required
                                @change="ordersPerMonth()"
                            />
                        </v-col>
                    </v-row>
                </v-container>
                <v-data-table
                    :headers="headers"
                    :items="currentMonthOrdersPerSource"
                    :mobile-breakpoint="0"
                    dense
                    hide-default-footer
                >
                    <template #item="{item}">
                        <tr>
                            <td>
                                {{ item.shopProductName }}
                            </td>
                            <td>
                                {{ item.currency }}
                            </td>
                            <td class="text-no-wrap">
                                {{ item.price }}
                            </td>
                            <td>
                                {{ item.ordersCount }}
                            </td>
                            <td>
                                {{ item.qtyTotal }}
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
import { findIndex } from 'lodash'

export default {
    name: 'ThreeMonthsReport',
    props: {
        widget: {
            type: Object,
            default: null
        },
        permissions: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            headers: [
                {
                    text: 'Produkt',
                    value: 'shopProductName',
                    sortable: false,
                },
                {
                    text: 'Waluta',
                    value: 'currency',
                    sortable: false
                },
                {
                    text: 'Kwota',
                    value: 'price',
                    sortable: false
                },
                {
                    text: 'Ilość zamówień',
                    value: 'ordersCount',
                    sortable: false
                },
                {
                    text: 'Nakład',
                    value: 'qty_total',
                    sortable: false
                },
            ],
            monthNames: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
                'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień'
            ],
            currentMonth: null,
            currentYear: null,
            sources: [],
            source: null,
            currentMonthOrdersPerSource: [],
            targetMonth: 4
        }
    },
    computed: {
        disableForward() {
            return this.targetMonth === 4
        },
        disableBackward() {
            return this.targetMonth === 1
        }
    },
    created() {
        this.setDate()
        this.setSources()
        this.ordersPerMonth()
    },
    methods: {
        previousMonth() {
            this.targetMonth--
            let index = this.monthNames.indexOf(this.currentMonth)

            if (index === 0) {
                this.currentMonth = this.monthNames[11]
                this.currentYear = `${new Date().getFullYear() - 1}`
            } else {
                this.currentMonth = this.monthNames[index - 1]
            }
            this.ordersPerMonth()
        },
        nextMonth() {
            this.targetMonth++
            let index = this.monthNames.indexOf(this.currentMonth)

            if (index === 11) {
                this.currentMonth = this.monthNames[0]
                this.currentYear = `${new Date().getFullYear()}`
            } else {
                this.currentMonth = this.monthNames[index + 1]
            }
            this.ordersPerMonth()
        },
        setSources() {
            this.widget.body.content.forEach(element => {
                const currentIndex = findIndex(this.sources, { 'name': element.name })

                if (currentIndex === -1) {
                    this.sources.push({
                        id: element.id,
                        name: element.name
                    })
                    if (element.name === 'Drukomat') {
                        this.source = {
                            id: element.id,
                            name: element.name
                        }
                    }
                }
            })
            if (this.sources.length > 0 && !this.source) {
                this.source = {
                    id: this.sources[0].id,
                    name: this.sources[0].name
                }
            }
        },
        setDate() {
            this.currentMonth = `${this.monthNames[new Date().getMonth()]}`
            this.currentYear = `${new Date().getFullYear()}`
        },
        ordersPerMonth() {
            this.currentMonthOrdersPerSource = []
            this.widget.body.content.forEach(element => {
                if (element.name === this.source.name && new Date(element.date).getMonth() === this.monthNames.indexOf(this.currentMonth)
                && (new Date(element.checkDate).getFullYear()).toString() === this.currentYear) {
                    this.currentMonthOrdersPerSource.push(element)
                }
            })
        }
    }
}
</script>
